export enum AsyncStateEnum {
  FINISHED = 'FINISHED',
  ERROR = 'ERROR OCCURRED',
  IN_PROGRESS = 'IN PROGRESS',
}

export type AsyncState = `${AsyncStateEnum}`;
